export default __webpack_public_path__ + "static/mann-1bb5163ab28845891376e867300af82c.png";